// Define template (for non-declarative use)
const template = document.createElement('template');

template.innerHTML = `
  <style>
    :host {
      display: block;
      border-radius: 5px;
      padding-left:15px;
      padding-right:5px;
      padding-top:5px;
      padding-bottom:5px;
      text-align: center;
    }
    .label {
      color:rgb(var(--text-color));
      height:100%;
      display:flex;
      padding-right:10px;
      align-items:center;
      font-weight: bold;
    }
    .values {
      display: flex;
      gap: 5px;
    }

    .values strong {
      display: inline-block;
    }
    @media screen and (min-width:1000px) {
      .values span {
        display:flex;
        flex-direction:column;  
        background-color:white;
        color: black!important;
        text-align:center;
        padding: 6px 4px;
        border-radius: 5px;
        font-size:9px;
        line-height:1;
        min-width:36px
      }

      .values strong {
        display: inline-block;
        font-size:2.6em;
      }
    }
  </style>
  <div class="label"></div>
  <div class="values">
    <span><strong class="days">00</strong> days</span>
    <span><strong class="hours">00</strong> hrs</span>
    <span><strong class="mins">00</strong> mins</span>
    <span><strong class="secs">00</strong> secs</span>
  </div>
`;

class CountdownTimer extends HTMLElement {
  static get observedAttributes() { return ['start','end']; }

  constructor() {
    super();
    // Check if shadow root already exists (declarative shadow DOM)
    if (!this.shadowRoot) {
      this.attachShadow({mode:'open'}).appendChild(template.content.cloneNode(true));
    }
    this._label = this.shadowRoot.querySelector('.label');
    this._days  = this.shadowRoot.querySelector('.days');
    this._hours = this.shadowRoot.querySelector('.hours');
    this._mins  = this.shadowRoot.querySelector('.mins');
    this._secs  = this.shadowRoot.querySelector('.secs');
    this._timer = null;
  }

  connectedCallback() {
    this._startTimer();
  }

  disconnectedCallback() {
    clearInterval(this._timer);
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (oldVal !== newVal) this._update();      
  }

  _startTimer() {
    this._update();
    this._timer = setInterval(() => this._update(), 1000);
  }

  _update() {
    const now = Date.now();
    const hasStart = this.hasAttribute('start');
    const hasEnd   = this.hasAttribute('end');
    const startTs  = hasStart ? this._parseTime('start') : NaN;
    const endTs    = hasEnd ? this._parseTime('end') : NaN;
    
    // Debug: log if dates failed to parse
    if (hasStart && isNaN(startTs)) {
      console.error('Failed to parse start date:', this.getAttribute('start'));
    }
    if (hasEnd && isNaN(endTs)) {
      console.error('Failed to parse end date:', this.getAttribute('end'));
    }

    // No dates at all
    if (!hasStart && !hasEnd) {
      this._label.textContent = 'No date specified';
      clearInterval(this._timer);
      return;
    }

    let diff, label;

    // Before start (if start given)
    if (hasStart && now < startTs) {
      diff  = startTs - now;
      label = 'Starts in:';

    // Between start and end (if both given)
    } else if (hasEnd && now <= endTs && (!hasStart || now >= startTs)) {
      diff  = endTs - now;
      label = 'Ends in:';

    // After end
    } else if (hasEnd && now > endTs) {
      this._label.textContent = 'Event ended';
      clearInterval(this._timer);
      return;

    // After start but no end
    } else if (hasStart && now >= startTs && !hasEnd) {
      this._label.textContent = 'Event started';
      clearInterval(this._timer);
      return;

    } else {
      // Catch-all (shouldn't hit)
      this._label.textContent = 'TEST';
      clearInterval(this._timer);
      return;
    }

    // Render countdown
    this._label.textContent = label;
    const days    = Math.floor(diff / 864e5);
    const hours   = Math.floor((diff % 864e5) / 36e5);
    const minutes = Math.floor((diff % 36e5) / 6e4);
    const seconds = Math.floor((diff % 6e4) / 1000);

    this._days .textContent = days;
    this._hours.textContent = String(hours).padStart(2,'0');
    this._mins .textContent = String(minutes).padStart(2,'0');
    this._secs .textContent = String(seconds).padStart(2,'0');
  }

  _parseTime(attr) {
    let raw = this.getAttribute(attr);
    if (!raw) return NaN;
    
    // Normalize format: fix single-digit hours/minutes/seconds
    // e.g., "2025-11-24T9:00:00" → "2025-11-24T09:00:00"
    raw = raw.replace(/T(\d):/, 'T0$1:')  // Hour
             .replace(/:(\d):/g, ':0$1:')  // Minutes
             .replace(/:(\d)$/, ':0$1');   // Seconds at end
    
    return new Date(raw).getTime();
  }
}

customElements.define('countdown-timer', CountdownTimer);